import loadable from '@utils/loadable';

import withMetatag from '../../decorators/metadataDecorators/metatagsTitleDecorator';
import withComponentName from '../../decorators/withComponentName';

import Preloader from '../../components/Preloader';

const WatchlistManagePageWrapper = loadable(
  () => import('../../components/WatchlistComponents/WatchlistManagePageWrapper'),
  { fallback: <div style={{ height: '100vh' }}><Preloader loading /></div> },
);

const WatchlistManagePage = (props) => {
  const {
    user, history, match,
    piwikEnabled,
  } = props;

  return (
    <WatchlistManagePageWrapper
      user={user}
      history={history}
      piwikEnabled={piwikEnabled}
      page={match.params.page}
    />
  );
};

export default withComponentName(withMetatag(WatchlistManagePage, 'watchlists/manage'));
